import React from 'react';
import { Dimmer, Table, Loader, Icon, Popup } from 'semantic-ui-react';
import TablePaginationMenu from '../../../components/TablePaginationMenu';
import { TableData } from '../../../services/dashboard';

interface DashboardTableProps {
  tableData: TableData[];
  tableLoading: boolean;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalItems: number;
}

const DashboardTable: React.FC<DashboardTableProps> = ({
  tableData,
  tableLoading,
  currentPage,
  setCurrentPage,
  totalItems
}) => {
  return (
    <Table singleLine>
      <Table.Header fullWidth>
        <Table.Row>
          <Table.HeaderCell textAlign="center">Imobiliária</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Franquia</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Fiança</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Incêndio</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Capitalização</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Sinistros</Table.HeaderCell>
          <Table.HeaderCell textAlign="center" collapsing>
            <Popup
              content={
                <div>
                  <p>
                    <b>Seguro Fiança:</b> O período selecionado se refere a data do pedido
                    de contratação.
                  </p>
                  <p>
                    <b>Seguro Incêndio:</b> O período selecionado se refere a data do
                    pedido de contratação.
                  </p>
                  <p>
                    <b>Capitalização:</b> O período selecionado se refere a data de
                    solicitação do Título.
                  </p>
                  <p>
                    <b>Sinistros:</b> O período selecionado se refere a data da
                    solicitação do sinistro.
                  </p>
                </div>
              }
              position={'top right'}
              trigger={
                <div
                  style={{
                    cursor: 'pointer',
                    color: '#2185D0'
                  }}
                >
                  <Icon name="info circle" />
                </div>
              }
            />
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Dimmer.Dimmable as={Table.Body} dimmed={tableLoading}>
        {tableLoading && (
          <Dimmer active blurring>
            <Loader />
          </Dimmer>
        )}
        {tableData.length > 0 ? (
          <>
            {tableData.map((item: TableData, index: number) => (
              <Table.Row key={index}>
                <Table.Cell textAlign="left">{item.estateName}</Table.Cell>
                <Table.Cell textAlign="center">
                  {item.franchiseName || 'Sem Franquia'}
                </Table.Cell>
                <Table.Cell textAlign="center">{item.bondInsurancePolicies}</Table.Cell>
                <Table.Cell textAlign="center">{item.fireInsurancePolicies}</Table.Cell>
                <Table.Cell textAlign="center">{item.capitalizationContracts}</Table.Cell>
                <Table.Cell textAlign="center" colSpan={2}>
                  {item.claims}
                </Table.Cell>
              </Table.Row>
            ))}
          </>
        ) : (
          <Table.Row>
            <Table.Cell colSpan={7} textAlign="center">
              <span>Nenhum registro encontrado</span>
            </Table.Cell>
          </Table.Row>
        )}
      </Dimmer.Dimmable>
      <Table.Footer fullWidth>
        <Table.Row>
          <Table.HeaderCell colSpan={7} textAlign="right">
            {!tableLoading && (
              <TablePaginationMenu
                currentPage={currentPage}
                dataCount={totalItems}
                setCurrentPage={setCurrentPage}
              />
            )}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default DashboardTable;
